import React from "react";

import {
	Button,
	Card,
	CardHeader,
	CardBody,
	Container,
	Form,
	UncontrolledTooltip,
	Table,
	FormGroup,
	Input,
	Row,
	Col,
	Label,
} from "reactstrap";
const paymentsTable = [
	{
		id: 1,
		nurseryName: "Grandmas Nursery",
		parentName: "Test Parent",
		paidOn: "2020-10-13",
		paidTo: "Grandmas Nursery",
		amount: 642,
	},
	{
		id: 2,
		nurseryName: "Grandmas Nursery",
		parentName: "Michelle Mallas",
		paidOn: "2020-11-25",
		paidTo: "Grandmas Nursery",
		amount: 664,
	},
	{
		id: 3,
		nurseryName: "Grandmas Nursery",
		parentName: "Test Parent",
		paidOn: "2020-12-24",
		paidTo: "Grandmas Nursery",
		amount: 864,
	},
	{
		id: 4,
		nurseryName: "Grandmas Nursery",
		parentName: "Test Parent",
		paidOn: "2020-10-14",
		paidTo: "Grandmas Nursery",
		amount: 864,
	},
];
function Payments() {
	return (
		<>
			<Container className="mt--0" fluid>
				<Row>
					<Col className="order-xl-1" xl="12">
						<Card  className="px-3">
							<CardHeader>
								<Row className="align-items-center">
									<Col xs="8">
										<h3 className="mb-0">Payments</h3>
									</Col>
									<Col className="text-right" xs="4"></Col>
								</Row>
							</CardHeader>
							<CardBody>
								<div className="pl-lg-4">
									<div>
										<Row>
											<Col lg="12">
												<div className="table-responsive">
													<Table className="align-items-center table-flush">
														<thead className="thead-light">
															<tr>
																<th className="sort" scope="col">
																	Id
																</th>
																<th className="sort" scope="col">
																	Nursery Name
																</th>
																<th className="sort" scope="col">
																	Parent Name
																</th>
																<th className="sort" scope="col">
																	Paid On
																</th>
																<th className="sort" scope="col">
																	Paid To
																</th>
																<th className="sort" scope="col">
																	Amount
																</th>
															</tr>
														</thead>
														<tbody className="list">
															{paymentsTable.map((data) => (
																<tr key={data.id}>
																	<td className="text-muted">
																		{data.id ?? ""}
																	</td>
																	<td className="text-muted">
																		{data.nurseryName ?? ""}
																	</td>
																	<td className="text-muted">
																		{data.parentName ?? ""}
																	</td>
																	<td className="text-muted">
																		{data.paidOn ?? ""}
																	</td>
																	<td className="text-muted">
																		{data.paidTo ?? ""}
																	</td>
																	<td className="text-muted">
																		{data.amount ?? ""}
																	</td>
																</tr>
															))}
															{paymentsTable.length < 1 && (
																<tr>
																	<td
																		className="text-center text-danger"
																		colSpan={5}
																	>
																		No Data Found
																	</td>
																</tr>
															)}
														</tbody>
													</Table>
												</div>
											</Col>
										</Row>
									</div>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	);
}

export default Payments;
